import { addColumnHeader, getNumericValue } from "../helpers";
import { getColumnData } from "../utils";
import Decimal from "decimal.js";
export const createFormula = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  addColumnHeader(outputSheet, outputColumns, rule.outputColumn);

  let columnData = getColumnData(
    worksheet,
    rule.inputColumn,
    fileSettings.headerRow,
  );

  let outputRow = 2;

  columnData.forEach((cellValue) => {
    const inputValue = getNumericValue(cellValue);

    let result = new Decimal(inputValue);
    rule.formula.forEach((step) => {
      const { operation, value } = step;
      const number = new Decimal(value);

      switch (operation) {
        case "/":
          result = result.div(number);
          break;
        case "*":
          result = result.mul(number);
          break;
        case "+":
          result = result.plus(number);
          break;
        case "-":
          result = result.minus(number);
          break;
        default:
          throw new Error(`Unsupported operation: ${operation}`);
      }
    });

    if (rule.roundTo) {
      result = result.toDecimalPlaces(rule.roundTo);
    }
    outputSheet.getCell(`${rule.outputColumn}${outputRow}`).value =
      result.toNumber();

    outputRow++;
  });
};
